module.exports = fox._r("images/player/banners/guest_freeReg_small.png", __webpack_public_path__ + "_/_/_/root/images/player/banners/guest_freeReg_small.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/player/banners/guest_freeReg_small.png
// module id = 898
// module chunks = 4